module.exports = __webpack_public_path__ + "img/full1-min.3d55af86.png";